<template>
    <span v-if="isArray">
        <div v-if="value[0] && typeof value[0]=== 'object'" class="ml-3">
            
            <ReNoteJsonItem v-for="(item,index) in value" :items="item" :key="index" />
        </div>
        <span v-else-if="value.length==1"   class="text-success pre-wrap">
            {{ value[0] }}
        </span>
        <div v-else v-for="(item,index) in value" :key="index"  class="text-success pre-wrap">
            • {{ item }}
        </div>
    </span>
    <span v-else class="text-success pre-wrap">{{ value }}</span>
</template>

<script>
import ReNoteJsonItem from './ReNoteJsonItem.vue';

export default {
    name: 'ReNoteJsonValue',
    components:{
        ReNoteJsonItem
    },
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array],
            required: true
        }
    },
    computed: {
        isArray() {
            return Array.isArray(this.value);
        },
    },
    beforeCreate(){
        this.$options.components.ReNoteJsonItem = ReNoteJsonItem;
    },
    methods: {

    }
}
</script>
